import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import bubblesort_cpp from "../codes/bubblesort_cpp";
import bubblesort_java from "../codes/bubblesort_java";
import bubblesort_py from "../codes/bubblesort_python";
import selectionsort_cpp from "../codes/selectionsort_cpp";
import selectionsort_java from "../codes/selectionsort_java";
import selectionsort_py from "../codes/selectionsort_python";
import insertionsort_cpp from "../codes/insertionsort_cpp";
import insertionsort_java from "../codes/insertionsort_java";
import insertionsort_py from "../codes/insertionsort_python";
import "../styles/codeboard.css";
import { CodeBlock } from "react-code-blocks";

const CodeBoard = (props) => {
  const [activeTab, setActiveTab] = useState("nav-home");
  const [language, setLanguage] = useState("cpp");

  return (
    <>
      <div className="bubblesort_code_container">
        <nav>
          <div className="nav nav-tabs" id="nav-tab" role="tablist">
            <button
              className={`nav-link ${activeTab === "nav-home" ? "active" : ""}`}
              id="nav-home-tab"
              data-bs-toggle="tab"
              type="button"
              role="tab"
              aria-controls="nav-home"
              onClick={() => {
                setActiveTab("nav-home");
                setLanguage("cpp");
              }}
            >
              C++
            </button>
            <button
              className={`nav-link ${
                activeTab === "nav-profile" ? "active" : ""
              }`}
              id="nav-profile-tab"
              data-bs-toggle="tab"
              type="button"
              role="tab"
              aria-controls="nav-profile"
              onClick={() => {
                setActiveTab("nav-profile");
                setLanguage("java");
              }}
            >
              Java
            </button>
            <button
              className={`nav-link ${
                activeTab === "nav-contact" ? "active" : ""
              }`}
              id="nav-contact-tab"
              data-bs-toggle="tab"
              type="button"
              role="tab"
              aria-controls="nav-contact"
              onClick={() => {
                setActiveTab("nav-contact");
                setLanguage("python");
              }}
            >
              Python
            </button>
          </div>
        </nav>
        <div className="tab-content" id="nav-tabContent">
          <div
            className="tab-pane fade show active"
            id="nav-home"
            role="tabpanel"
            aria-labelledby="nav-home-tab"
          >
            <CodeBlock
              text={
                props.code === "bubblesort"
                  ? language === "cpp"
                    ? bubblesort_cpp
                    : language === "java"
                    ? bubblesort_java
                    : bubblesort_py
                  : props.code === "selectionsort"
                  ? language === "cpp"
                    ? selectionsort_cpp
                    : language === "java"
                    ? selectionsort_java
                    : selectionsort_py
                  : props.code === "insertionsort"
                  ? language === "cpp"
                    ? insertionsort_cpp
                    : language === "java"
                    ? insertionsort_java
                    : insertionsort_py
                  : ""
              }
              language={language}
              showLineNumbers={true}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CodeBoard;
